/* Fardo.cl - Boton unico "Comprar ahora" con el resumen adentro,
   mas el recalculo de la cuota Venti segun el tramo elegido.

   Estilos y formato de moneda: snippets/fardo-buy-summary.liquid
   Datos de precio por tramo: script[data-tier-prices] de tier-price-cards.liquid

   No se crea un boton nuevo: se escribe dentro del boton de checkout
   dinamico de Shopify, asi que el click sigue siendo el nativo y lleva
   directo al checkout.
*/
(function () {
  var RAW_FMT = (window.FARDO_MONEY_FORMAT || '${{amount_no_decimals_with_comma_separator}}');
  var FMT = String(RAW_FMT).replace(/<[^>]*>/g, '');

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = (precision == null) ? 2 : precision;
    thousands = (thousands == null) ? ',' : thousands;
    decimal = (decimal == null) ? '.' : decimal;
    if (isNaN(number) || number == null) return '0';
    var fixed = (number / 100.0).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return whole + (parts[1] ? decimal + parts[1] : '');
  }

  function money(cents) {
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = FMT.match(re);
    var value;
    switch (m && m[1]) {
      case 'amount': value = formatWithDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = formatWithDelimiters(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = formatWithDelimiters(cents, 0, ' '); break;
      case 'amount_with_space_separator': value = formatWithDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_period_and_space_separator': value = formatWithDelimiters(cents, 2, ' ', '.'); break;
      default: value = formatWithDelimiters(cents, 2);
    }
    return FMT.replace(re, value);
  }

  function variantData(form) {
    var container = form.querySelector('[data-tier-cards]');
    if (!container) return null;
    var tag = container.querySelector('script[data-tier-prices]');
    if (!tag) return null;
    var data;
    try { data = JSON.parse(tag.textContent); } catch (err) { return null; }
    if (!data) return null;
    var idInput = form.querySelector('[name="id"]');
    var vid = idInput ? String(idInput.value) : null;
    if (vid && data[vid]) return data[vid];
    var keys = Object.keys(data);
    return keys.length ? data[keys[0]] : null;
  }

  /* Precio unitario del tramo que corresponde a la cantidad elegida. */
  function unitPrice(vdata, qty) {
    if (!vdata) return null;
    var best = null;
    Object.keys(vdata.tiers || {}).forEach(function (key) {
      var threshold = parseInt(key, 10);
      var tier = vdata.tiers[key];
      if (!tier || !tier.ok || isNaN(threshold)) return;
      if (qty >= threshold && (best === null || threshold > best.threshold)) {
        best = { threshold: threshold, price: tier.price };
      }
    });
    if (best) return best.price;
    return (typeof vdata.price === 'number') ? vdata.price : null;
  }

  /* Palabra de la unidad (Saco / Fardo / Caja / Pack) leida de las cajas. */
  function unitWords(form) {
    var out = { one: 'unidad', many: 'unidades' };
    var container = form.querySelector('[data-tier-cards]');
    if (!container) return out;
    var labels = container.querySelectorAll('.fardo-tier-card__qty');
    if (labels.length) {
      var one = labels[0].textContent.trim().replace(/^[\d+\s]+/, '');
      if (one) out.one = one;
      out.many = out.one + 's';
    }
    if (labels.length > 1) {
      var many = labels[1].textContent.trim().replace(/^[\d+\s]+/, '');
      if (many) out.many = many;
    }
    return out;
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"]/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[ch];
    });
  }

  /* Widget Venti: la cuota se calcula sobre el total del tramo elegido,
     no sobre una unidad. El numero de cuotas lo dicta el propio widget. */
  function updateVenti(qty, unit) {
    var box = document.getElementById('__ventipay_product_installments_block');
    if (!box) return;
    var strongs = box.querySelectorAll('strong');
    if (strongs.length < 2) return;

    var match = strongs[0].textContent.match(/(\d+)/);
    var installments = match ? parseInt(match[1], 10) : 0;
    if (!installments) return;

    var target = strongs[strongs.length - 1];
    var text = money(Math.round(unit * qty / installments));
    if (target.textContent !== text) target.textContent = text;
  }

  function update(form) {
    var input = form.querySelector('input[name="quantity"]');
    var qty = parseInt(input && input.value, 10);
    if (!qty || qty < 1) qty = 1;

    var vdata = variantData(form);
    var unit = unitPrice(vdata, qty);
    if (unit == null) return;

    updateVenti(qty, unit);

    var btn = form.querySelector('.product-add-to-cart-container .shopify-payment-button__button--unbranded');
    if (!btn) return;

    var inner = btn.querySelector('[data-fardo-buy-inner]');
    if (!inner) {
      var label = (btn.textContent || '').trim() || 'Comprar ahora';
      btn.__fardoLabel = label;
      btn.classList.add('fardo-buy-now');
      btn.innerHTML =
        '<span class="fardo-buy-inner" data-fardo-buy-inner>' +
          '<span class="fardo-buy-inner__title"></span>' +
          '<span class="fardo-buy-inner__detail"></span>' +
        '</span>';
      inner = btn.querySelector('[data-fardo-buy-inner]');
    }

    var titleEl = inner.querySelector('.fardo-buy-inner__title');
    var detailEl = inner.querySelector('.fardo-buy-inner__detail');
    if (!titleEl || !detailEl) return;

    var title = btn.__fardoLabel || 'Comprar ahora';
    if (titleEl.textContent !== title) titleEl.textContent = title;

    var words = unitWords(form);
    var word = (qty === 1) ? words.one : words.many;
    var html = escapeHtml(qty + ' ' + word) + ' por <b>' + escapeHtml(money(unit * qty)) + '</b> en total';
    if (detailEl.innerHTML !== html) detailEl.innerHTML = html;
  }

  function updateAll() {
    document.querySelectorAll('product-form').forEach(update);
  }

  function schedule() {
    clearTimeout(window.__fardoBuySummaryTimer);
    window.__fardoBuySummaryTimer = setTimeout(updateAll, 60);
  }

  document.addEventListener('input', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[name="quantity"]')) schedule();
  });
  document.addEventListener('change', schedule);
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-tier], quantity-selector')) schedule();
  });
  document.addEventListener('mouseover', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-tier]')) schedule();
  });
  document.addEventListener('mouseout', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-tier]')) schedule();
  });

  function init() {
    updateAll();

    document.querySelectorAll('.product-add-to-cart-container').forEach(function (node) {
      if (node.__fardoSummaryWatched) return;
      node.__fardoSummaryWatched = true;
      new MutationObserver(schedule).observe(node, { childList: true, subtree: true });
    });

    var venti = document.getElementById('__ventipay_product_installments_block');
    if (venti && !venti.__fardoSummaryWatched) {
      venti.__fardoSummaryWatched = true;
      new MutationObserver(schedule).observe(venti, { childList: true, subtree: true, characterData: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 900);
  setTimeout(init, 2200);
})();